import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

interface SidebarEndorsementQueueBadgeProps {
  count: number;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarEndorsementQueueBadge({
  count,
  variant,
}: SidebarEndorsementQueueBadgeProps) {
  const { t } = useTranslation('endossos');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-endorsement-queue-badge"
      label={t('queue.sidebar_badge', { count })}
    />
  );
}
